import { useQuery } from '@tanstack/react-query';
import { QuestionCourseRepositoryImpl } from '../../data/repository/question_course_repository';
import { QuestionCourseInterface } from '../interface/question_course_interface';
import { AxiosError } from 'axios';

export const useGetStartQuestionCourse = () => {
  const repository = new QuestionCourseRepositoryImpl();

  return useQuery<QuestionCourseInterface[], AxiosError>({
    queryKey: ['question-course', 'start'],
    queryFn: () => repository.getStartQuestionCourse(),
  });
};

export const useGetEndQuestionCourse = (enabled: boolean = true) => {
  const repository = new QuestionCourseRepositoryImpl();

  return useQuery<QuestionCourseInterface[], AxiosError>({
    queryKey: ['question-course', 'end'],
    queryFn: () => repository.getEndQuestionCourse(),
    enabled,
  });
};
